// extracted by mini-css-extract-plugin
export default {"room-message":"roomMessage_room-message__IywHH","room-message--buyer":"roomMessage_room-message--buyer__hqlpc","room-message--seller":"roomMessage_room-message--seller__2Wkjm"};